<template>
  <div class="sider" :style="{ width: collapse ? '64px' : '200px' }">
    <el-menu
      router
      :default-active="activeMenu"
      :collapse="collapse"
      :unique-opened="false"
      active-text-color="#FFFFFF"
      :collapse-transition="false"
      mode="vertical"
    >
      <SubMenu :subMenuList="allRouter" v-if="allRouter.length"></SubMenu>
    </el-menu>
  </div>
</template>

<script>
import { permissionsRoute } from "@/router/index";
import SubMenu from "./subMenu";
import { filterRoutes } from "@/store/modules/user";

export default {
  name: "Sider",
  props: {
    collapse: {
      type: Boolean,
      default: false,
    },
  },
  components: { SubMenu },
  computed: {
    activeMenu() {
      const route = this.$route;
      const { meta, fullPath } = route;
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      return fullPath;
    },
  },
  data() {
    return {
      allRouter: [],
    };
  },
  mounted() {
    this.allRouter = filterRoutes(permissionsRoute, [
      this.$store.state.user.userInfo.role,
    ]);
  },
  methods: {},
};
</script>


<style lang="scss" scoped>
.sider {
  //width: 200px;
  overflow-y: auto;
  overflow-x: hidden;
}

.el-menu {
  height: 100%;
}
/* 折叠态彻底隐藏文字，防止露一点 */
::v-deep .el-menu--collapse .el-submenu__title span,
::v-deep .el-menu--collapse .el-menu-item span {
  display: none !important;
}

::v-deep .el-menu--collapse .el-submenu__icon-arrow {
  display: none !important;
}
</style>